"use client";

/**
 * ia-ui 第2波: ヘッダ編集欄（ステージ/出発日/ウォッチ）の自動保存状態を表示する
 * 共通の小コンポーネント。ProjectManagementBar と案件ページで同じ見た目・文言を使う。
 * 保存は即時 PATCH のまま。この表示は結果のフィードバックのみを担う。
 */
export type SaveState =
  | { status: "idle" }
  | { status: "saving" }
  | { status: "saved"; at: number }
  | { status: "error" };

function formatHHMM(at: number): string {
  return new Date(at).toLocaleTimeString("ja-JP", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function SaveStatusIndicator({
  state,
  onRetry,
}: {
  state: SaveState;
  onRetry?: () => void;
}) {
  if (state.status === "idle") return null;

  if (state.status === "saving") {
    return (
      <span className="text-xs text-zinc-400" aria-live="polite">
        保存中…
      </span>
    );
  }

  if (state.status === "saved") {
    return (
      <span className="text-xs text-emerald-600" aria-live="polite">
        ✓ 保存しました {formatHHMM(state.at)}
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center gap-1.5 text-xs text-red-600"
      aria-live="polite"
    >
      保存に失敗しました
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="font-medium underline hover:text-red-700"
        >
          再試行
        </button>
      )}
    </span>
  );
}
